//? Dto

import { z } from "zod";
import { apiListSchema } from "./list";

export const CreateRegionDtoSchema = z.object({
  Name: z.string(),
  Description: z.string().nullish(),
  Color: z.string().nullish(),
});

export type CreateRegionDto = z.infer<typeof CreateRegionDtoSchema>;

export const RegionDtoSchema = CreateRegionDtoSchema.extend({
  Id: z.number(),
});

export type RegionDto = z.infer<typeof RegionDtoSchema>;

export const regionDtoListSchema = apiListSchema(RegionDtoSchema);

//? Model
export const CreateRegionSchema = z.object({
  name: z.string().min(1),
  description: z.string().nullish(),
  color: z.string().nullish(),
});

export const RegionSchema = CreateRegionSchema.extend({
  id: z.string().min(1),
});

export type CreateRegion = z.infer<typeof CreateRegionSchema>;

export type Region = z.infer<typeof RegionSchema>;

//? Mappers
export function regionFromDto(dto: RegionDto): Region {
  return {
    id: dto.Id.toString(),
    name: dto.Name,
    description: dto.Description ?? "",
    color: dto.Color,
  };
}

export function regionToDto(dto: Region): RegionDto {
  return {
    Id: Number.parseInt(dto.id),
    ...createRegionToDto(dto),
  };
}

export function createRegionToDto(dto: CreateRegion): CreateRegionDto {
  return {
    Name: dto.name,
    Description: dto.description,
    Color: dto.color,
  };
}
